var hereford = hereford || {};
( function () {
    'use strict';
    jQuery( window ).scroll( function () {
        var scroll = jQuery( window ).scrollTop();
        if ( scroll >= 500 ) {
            jQuery( ".e-header" ).addClass( "hereford-header-scroll-background" );
        }
        else {
            jQuery( ".e-header" ).removeClass( "hereford-header-scroll-background" );
        }
    } );
    jQuery( function () {
        hereford.initOnReady();
    } );
    jQuery( window ).on( 'load', function () {
        hereford.initOnLoad();
    } );
    hereford.initOnReady = function () {
        hereford.navigationSetTarget.init();
        hereford.video.fit();
        hereford.svg.init();
        hereford.gdpr.init();
        hereford.instafeed.init();
        hereford.tileObjectfit.init();
        hereford.formDropup.init();
        hereford.chromatic();
        hereford.card.init();
    };
    hereford.card = {
        init: function () {
            hereford.card.collapse();
        },
        collapse: function () {
            jQuery('.js-ahb-card-collapse').find('.js-ahb-card-collapse-btn').on('click', function(){
                var jText = jQuery(this).closest('.js-ahb-card-collapse').find('.ahb-card-collapse-text'),
                    jBtnReadMore = jQuery(this).find('.js-ahb-card-collapse-btn-readmore'),
                    jBtnReadLess = jQuery(this).find('.js-ahb-card-collapse-btn-readless');
                
                if( jText.hasClass('collapsed') ) {
                    jText.addClass('open');
                    jText.removeClass('collapsed');
                    jBtnReadLess.show();
                    jBtnReadMore.hide();
                } else {
                    jText.removeClass('open');
                    jText.addClass('collapsed');
                    jBtnReadLess.hide();
                    jBtnReadMore.show();
                }
            });
        }
    };
    hereford.initOnLoad = function () { 
        hereford.video.play();
    };
    hereford.utils = {
        isTouchDevice: function () {
            return 'ontouchstart' in window || navigator.maxTouchPoints;
        }
    };
    hereford.video = {
        fit: function () {
            var jVideo = jQuery( '.js-hereford-video-movie' );
        },
        play: function () {
            var jVideo = jQuery( '.js-hereford-video-movie' );
            if ( jVideo.length > 0 ) {
                jVideo.addClass( 'is-ready' );
                jVideo.get( 0 ).play();
            }
        }
    };
    hereford.formDropup = {};
    hereford.formDropup.init = function () {
        // Checkbox list inside dropdown
        var options = [];
    jQuery( '.dropup a' ).on( 'click', function ( event ) {
        var $target = $( event.currentTarget ),
                val = $target.attr( 'data-value' ),
                $inp = $target.find( 'input' ),
                idx;
        if ( ( idx = options.indexOf( val ) ) > -1 ) {
            options.splice( idx, 1 );
            setTimeout( function () {
                $inp.prop( 'checked', false );
            }, 0 );
        }
        else {
            options.push( val );
            setTimeout( function () {
                $inp.prop( 'checked', true );
            }, 0 );
        }
        jQuery( event.target ).blur();
        console.log( options );
        return false;
    } );
    };
    hereford.chromatic = function () {
        var jChromatic = jQuery( '.js-e-chromatic' );
        if ( jChromatic.length > 0 ) {
            jChromatic.each( function () {
                var jChromaticGallery = jQuery( this ),
                    jChromaticGalleryItems = jChromaticGallery.find( '.js-e-chromatic-item' ),
                    arrChromaticImages = [];
                jChromaticGalleryItems.each( function () {
                    var jThis = jQuery( this ),
                        jThisImage = jThis.find( '.js-e-chromatic-img' );
                    arrChromaticImages.push( {
                        small: jThisImage.attr( 'src' ),
                        big: jThisImage.data( 'large-src' ),
                        caption: jQuery.trim( jThis.find( '.js-e-chromatic-caption' ).html() )
                    } );
                } );
                jChromaticGallery.empty().chromatic( arrChromaticImages );
            } );
        }
    };
    hereford.svg = {};
    hereford.svg.init = function () {
        jQuery( 'img.svg' ).each( function () {
            var $img = jQuery( this );
            var imgID = $img.attr( 'id' );
            var imgClass = $img.attr( 'class' );
            var imgURL = $img.attr( 'src' );

            jQuery.get( imgURL, function ( data ) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery( data ).find( 'svg' );

                // Add replaced image's ID to the new SVG
                if ( typeof imgID !== 'undefined' ) {
                    $svg = $svg.attr( 'id', imgID );
                }
                // Add replaced image's classes to the new SVG
                if ( typeof imgClass !== 'undefined' ) {
                    $svg = $svg.attr( 'class', imgClass + ' replaced-svg' );
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr( 'xmlns:a' );

                // Replace image with new SVG
                $img.replaceWith( $svg );

            }, 'xml' );
        } );
    };
    hereford.navigationSetTarget = {
        init: function () {
            jQuery( '.e-nav-local .nav-link[href^="http"]' ).attr( 'target', '_blank' );
        }
    };
    hereford.gdpr = {
        lang: jQuery( 'html' ).attr( 'lang' ),
        init: function () {
            hereford.gdpr.add();
        },
        add: function () {
            jQuery( 'form' ).find( 'label, .form-group' ).each( function () {
                var html = jQuery( this ).html();
                if ( html.indexOf( '{gdpr1}' ) > -1 ) {
                    html = html.replace( '{gdpr1}', '<a class="text-auto text-decoration-underline" href="' + window.gdprData[hereford.gdpr.lang].gdpr1.url + '" target="_blank">' + window.gdprData[hereford.gdpr.lang].gdpr1.link + '</a>' );
                    jQuery( this ).html( html );
                }
                if ( html.indexOf( '{gdpr2}' ) > -1 ) {
                    html = html.replace( '{gdpr2}', '<a class="text-auto text-decoration-underline" href="' + window.gdprData[hereford.gdpr.lang].gdpr2.url + '" target="_blank">' + window.gdprData[hereford.gdpr.lang].gdpr2.link + '</a>' );
                    jQuery( this ).html( html );
                }
            } );
        }
    };
    hereford.tileObjectfit = {};
    hereford.tileObjectfit.init = function () {
        $( '.p-tile-container img' ).each( function () {
            var t = $( this ),
                s = 'url(' + t.attr( 'src' ) + ')',
                p = t.parent(),
                d = $( '<div></div>' );
            t.hide();
            p.append( d );
            d.css( {
                'height': '100%',
                'background-size': 'cover',
                'background-repeat': 'no-repeat',
                'background-position': 'center',
                'background-image': s
            } );
        } );
    }
    hereford.instafeed = {};
    hereford.instafeed.init = function () {
        if ( jQuery( '#instagram-feed' ).length ) {
            var jFeed = jQuery( '.instagram-feed' ),
                jLimit = parseInt( jFeed.data( 'limit' ) ),
                //jSort = jFeed.data('sortby'),
                jCaption = jFeed.data( 'caption' ),
                jCaptions = '',
                jUser = jFeed.data( 'user' ),
                jToken = jFeed.data( 'token' );
            if ( jCaption === 'True' ) {
                jCaptions = '<div class="instagram-feed-item-caption"><p>{{caption}}</p></div>';
            }
            var userFeed = new Instafeed( {
                get: 'user',
                userId: jUser,
                accessToken: jToken,
                limit: jLimit,

                //sortBy: jSort,
                /*filter: function(jImage) {
                    var jTags = jFeed.data('tags');
                    if (jTags !== '') {
                        //var test = jImage.tags.join(', ');
                        //console.log(jImage.tags.indexOf(jTags));
                        //console.log(test.indexOf(jTags));
                        //console.log(test);
                        return jImage.tags.indexOf(jTags) >= 0;
                    }
                },*/

                target: 'instagram-feed',
                resolution: 'standard_resolution',
                template: '<div class="instagram-feed-item"><a style="background-image:url({{image}}); background-size:cover; display:block; height: 100%;" href="{{link}}" target="_blank"><img src="/Files/Templates/Designs/hereford/assets/img/trans.png"/>' + jCaptions + '</a></div>'
            } );
            userFeed.run();
        }
    };
}() );
// https://github.com/constancecchen/object-fit-polyfill
// http://walterebert.com/blog/html5-video-autoplay-mobile-revisited/
